import fetcher_v2 from "../fetcher_v2";
import { URLS } from "../urls";

export type MessageBody = {
  subject?: string;
  name: string;
  email: string;
  message?: string;
  type: string;
};

export const messageSales = (body: MessageBody) => {
  return fetcher_v2<void, MessageBody>(URLS.MESSAGE, { body, method: "POST" });
};
